var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseAction(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "black",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Close_2",
    d: "M12.182 11.3902L9.79231 9.00056L12.182 6.61089C12.287 6.50582 12.3461 6.36332 12.3461 6.21473C12.3461 6.06615 12.287 5.92364 12.182 5.81858C12.0769 5.71351 11.9344 5.65448 11.7858 5.65448C11.6372 5.65448 11.4947 5.71351 11.3897 5.81858L9 8.20824L6.61033 5.81858C6.50527 5.71351 6.36276 5.65448 6.21418 5.65448C6.06559 5.65448 5.92309 5.71351 5.81802 5.81858C5.71295 5.92364 5.65393 6.06615 5.65393 6.21473C5.65393 6.36332 5.71295 6.50582 5.81802 6.61089L8.20769 9.00056L5.81802 11.3902C5.71295 11.4953 5.65393 11.6378 5.65393 11.7864C5.65393 11.935 5.71295 12.0775 5.81802 12.1825C5.92309 12.2876 6.06559 12.3466 6.21418 12.3466C6.36276 12.3466 6.50527 12.2876 6.61033 12.1825L9 9.79287L11.3897 12.1825C11.4947 12.2876 11.6372 12.3466 11.7858 12.3466C11.9344 12.3466 12.0769 12.2876 12.182 12.1825C12.287 12.0775 12.3461 11.935 12.3461 11.7864C12.3461 11.6378 12.287 11.4953 12.182 11.3902Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseAction);
export default __webpack_public_path__ + "static/media/CloseAction.0a97e0325c112da9513de7198f0436bf.svg";
export { ForwardRef as ReactComponent };